const NumberMedia = () => import('@/views/tourist/media/NumberMedia')
const StatisticsTourists = () => import('@/views/tourist/media/StatisticsTourists')
const Influencer = () => import('@/views/tourist/media/Influencer')

const mainWidget = [
  {
    title: 'ช่องทาง Social Media ที่คนนิยมใช้ สนทนา/หาข้อมูล ด้านท่องเที่ยว (รายวัน)',
    path: '/admin/widget/:category/:widget_code(1)',
    component: NumberMedia,
  },
  {
    title: 'สถิติการรับรู้ข้อมูลข่าวสาร ด้านการท่องเที่ยว ผ่านช่องทางต่างๆ ของ ชาวไทย/ชาวต่างประเทศ',
    path: '/admin/widget/:category/:widget_code(2)',
    component: StatisticsTourists,
  },
  {
    title: 'รายชื่อ Influencer ที่มีอิทธิพลต่อด้านการท่องเที่ยว',
    path: '/admin/widget/:category/:widget_code(6)',
    component: Influencer,
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})
